import { IIncentiveSend } from 'src/types/incentive';
import { IncentiveFormData } from 'src/screens/General/screens/Incentives/components/IncentiveForm';
import { changeToZeroMoment } from '../timeHelpers';
import moment from 'moment/moment';

const groupIncentive = (dataForm: Partial<IncentiveFormData>): Partial<IIncentiveSend> => {
    const { dateFrom, dateTo, ...restData } = dataForm;
    const dataSend: Partial<IIncentiveSend> = { ...restData };
    const arrProviders = Object.keys(restData.providers).map((key) => {
        return +key;
    });

    /*if (dateFrom) {
        dataSend.dateFrom = changeToZeroMoment(dateFrom, 'YYYY-MM-DD');
    }
    if (dateTo) {
        dataSend.dateTo = changeToZeroMoment(dateTo, 'YYYY-MM-DD');
    }*/

    const hoursStart = +moment(dateFrom).format('H');
    const minStart = +moment(dateFrom).format('m');
    dataSend.dateFrom = moment(dateFrom).set('hour', hoursStart).set('minute', minStart).format('YYYY-MM-DD HH:mm:ss');

    const hoursEnd = +moment(dateTo).format('H');
    const minEnd = +moment(dateTo).format('m');
    dataSend.dateTo = moment(dateTo)
        .set('hour', hoursEnd)
        .set('minute', minEnd)
        .set('second', 0)
        .format('YYYY-MM-DD HH:mm:ss');

    delete restData.providers;

    return {
        ...dataSend,
        providers: arrProviders,
    };
};
export { groupIncentive };
